module.exports = __webpack_public_path__ + "img/onboarding_icon_4.e7a3b73a.svg";